
export type Color = "danger" | "success" | "warning" | "primary" | "secondary" | "unabled";
import {
  type InactiveByEdition,
  type InProccessStatus,
  type MaterialPendingStatus,
  type RefusedStatus,
  type RequestAdditionStatuses,
} from "../types/requestAddition";

export const REFUSED_STATUS: RefusedStatus = 0;
export const IN_PROCCESS_STATUS: InProccessStatus = 2;
export const INACTIVE_BY_EDITION: InactiveByEdition = 3;
export const MATERIAL_PENDING_STATUS: MaterialPendingStatus = 4;

export const REQUEST_ADDITION_STATUSES: RequestAdditionStatuses[] = [
  REFUSED_STATUS,
  IN_PROCCESS_STATUS,
  INACTIVE_BY_EDITION,
  MATERIAL_PENDING_STATUS,
];

export const REQUEST_ADDITION_STATUS_COLOR: Record<
  RequestAdditionStatuses,
  Color
> = {
  [REFUSED_STATUS]: "danger",
  [IN_PROCCESS_STATUS]: "warning",
  [INACTIVE_BY_EDITION]: "unabled",
  [MATERIAL_PENDING_STATUS]: "primary",
};

export const REQUEST_ADDITION_STATUS_CONTENT: Record<
  RequestAdditionStatuses,
  string
> = {
  [REFUSED_STATUS]: "Recusado",
  [IN_PROCCESS_STATUS]: "Solicitação Recebida",
  [INACTIVE_BY_EDITION]: "Inativado pela Edição",
  [MATERIAL_PENDING_STATUS]: "Material Pendente",
};
